// Données 100 % FICTIVES du restaurant exemple de la démo interactive.
// Aucune donnée réelle de restaurant — présentées comme simulation dans l'UI.
// Le profil s'adapte à la région (devise, ville, ordres de grandeur) et à la langue.

const BASE = { monthlyGuests: 1240, weeklyBookings: 186, rating: 4.2, reviews: 187, idleOccupancy: 41, inactiveCustomers: 312, score: 61 };

// Ordres de grandeur plausibles par marché (CHF vs zones EUR nord / sud).
const TIERS = {
  chf: { monthlyRevenue: 68400, averageTicket: 55, amounts: [1450, 1520, 880] },
  eurNorth: { monthlyRevenue: 52600, averageTicket: 42, amounts: [1100, 1180, 670] },
  eurSouth: { monthlyRevenue: 41800, averageTicket: 34, amounts: [880, 940, 530] },
};

const MARKETS = {
  CH: { tier: 'chf', name: 'Le Petit Jardin', city: { fr: 'Lausanne', de: 'Zürich', it: 'Lugano', default: 'Genève' } },
  LI: { tier: 'chf', name: 'Gasthaus Lindenhof', city: { default: 'Vaduz' } },
  FR: { tier: 'eurNorth', name: 'Le Petit Jardin', city: { default: 'Lyon' } },
  BE: { tier: 'eurNorth', name: 'Le Petit Jardin', city: { default: 'Bruxelles' } },
  LU: { tier: 'eurNorth', name: 'Le Petit Jardin', city: { default: 'Luxembourg' } },
  DE: { tier: 'eurNorth', name: 'Gasthaus Lindenhof', city: { default: 'München' } },
  AT: { tier: 'eurNorth', name: 'Gasthaus Lindenhof', city: { default: 'Wien' } },
  IT: { tier: 'eurSouth', name: 'Trattoria Il Giardino', city: { default: 'Milano' } },
  ES: { tier: 'eurSouth', name: 'Restaurante El Jardín', city: { default: 'Madrid' } },
  PT: { tier: 'eurSouth', name: 'Restaurante O Jardim', city: { default: 'Lisboa' } },
};

const initials = (name) => name.replace(/^(Le|La|Il|El|O|Gasthaus|Trattoria|Restaurante)\s+/i, '')
  .split(/\s+/).map(w => w[0]).join('').slice(0, 2).toUpperCase();

export const ACTION_KEYS = ['r1', 'r2', 'r3'];
const ACTION_META = {
  r1: { priority: 'high', effort: 'low', color: '#FBBF24' },
  r2: { priority: 'high', effort: 'low', color: '#34D399' },
  r3: { priority: 'medium', effort: 'medium', color: '#60A5FA' },
};

// `?country=FR` sur /demo ou /demo-interactive : aperçu d'un autre marché (démo uniquement).
export function demoCountryOverride(search) {
  const c = (new URLSearchParams(search || '').get('country') || '').toUpperCase();
  return MARKETS[c] ? c : null;
}

export function getDemoProfile(country, lang) {
  const m = MARKETS[(country || 'CH').toUpperCase()] || MARKETS.CH;
  const tier = TIERS[m.tier];
  const actions = ACTION_KEYS.map((key, i) => ({ key, amount: tier.amounts[i], ...ACTION_META[key] }));
  const code = MARKETS[(country || '').toUpperCase()] ? country.toUpperCase() : 'CH';
  return {
    ...BASE,
    // devise cohérente avec le marché du restaurant exemple (indépendante du cache région)
    region: { country: code, currency: m.tier === 'chf' ? 'CHF' : 'EUR' },
    name: m.name,
    initials: initials(m.name),
    city: m.city[lang] || m.city.default,
    monthlyRevenue: tier.monthlyRevenue,
    averageTicket: tier.averageTicket,
    actions,
    total: actions.reduce((s, a) => s + a.amount, 0),
  };
}

export const DEMO_STEPS = ['restaurant', 'analysis', 'result', 'actions'];

// Drapeaux de session pour le funnel (jamais de donnée personnelle).
export const DEMO_FLAGS = {
  started: 'cop_demo_started',
  origin: 'cop_demo_origin',
  activationTracked: 'cop_demo_activation_tracked',
};

export const sessionFlag = {
  get: (k) => { try { return sessionStorage.getItem(k) === '1'; } catch { return false; } },
  set: (k) => { try { sessionStorage.setItem(k, '1'); } catch { /* ignore */ } },
  clear: (k) => { try { sessionStorage.removeItem(k); } catch { /* ignore */ } },
};
